'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getValueString = exports.column = exports.legacyDirection = exports.oppositeDirection = exports.getValueUnit = exports.stripUnit = undefined;

var _constants = require('./constants/constants');

var stripUnit = exports.stripUnit = function stripUnit(value) {
  if (!value) throw new TypeError('Value is not defined');

  if (typeof value === 'string' && value !== 'inherit') return value.match(/^\d+/)[0];else if (isFinite(value) || value === 'inherit') return value;

  throw new TypeError('Wrong value type');
};

var getValueUnit = exports.getValueUnit = function getValueUnit(value) {
  if (!value) throw new TypeError('Value is not defined');

  if (typeof value === 'string') return value.match(/\D+/);else if (typeof value === 'number') return '';

  throw new TypeError('Wrong value type');
};

var oppositeDirection = exports.oppositeDirection = function oppositeDirection(direction) {
  var directionMap = {
    top: 'bottom',
    right: 'left',
    bottom: 'top',
    left: 'right',
    center: 'center',
    ltr: 'rtl',
    rtl: 'ltr'
  };

  return directionMap[direction];
};

var legacyDirection = exports.legacyDirection = function legacyDirection(direction) {
  var directionMap = {
    'to top': 'bottom',
    'to top right': 'bottom left',
    'to right top': 'left bottom',
    'to right': 'left',
    'to bottom right': 'top left',
    'to right bottom': 'left top',
    'to bottom': 'top',
    'to bottom left': 'top right',
    'to left bottom': 'right top',
    'to left': 'right',
    'to left top': 'right bottom',
    'to top left': 'bottom right'
  };

  if (!directionMap[direction.toLowerCase()]) throw new TypeError('Wrong direction value: \'' + direction + '\'');

  return directionMap[direction.toLowerCase()];
};

/**
 * Generate columns
 */
var column = exports.column = function column(amount) {
  var totalColumns = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _constants.grid.totalColumns;

  if (!isFinite(amount) || !isFinite(totalColumns)) throw new TypeError('Wrong value type. Number expected.');

  var result = amount * 100 / totalColumns;

  return result ? result + '%' : result;
};

var getValueString = exports.getValueString = function getValueString(value) {
  return typeof value === 'number' ? value + 'px' : value;
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-core/dist/styleFunctions.js
// module id = 211
// module chunks = 0